import {
  applySoftKeyboardViewport,
  resolveSoftKeyboardViewport,
  shouldResetScrollForSoftKeyboard,
} from 'features/embeddedSidebar/hooks/useSoftKeyboardViewport/softKeyboardViewport'
import { useEffect } from 'react'

export function useSoftKeyboardViewport(enabled: boolean): void {
  useEffect(() => {
    const viewport = window.visualViewport
    if (!enabled || !viewport) return
    const rootStyle = document.documentElement.style

    const sync = () => {
      const state = resolveSoftKeyboardViewport({
        layoutHeight: window.innerHeight,
        visualHeight: viewport.height,
      })
      applySoftKeyboardViewport(rootStyle, state)
      if (
        shouldResetScrollForSoftKeyboard(
          state.keyboardOpen,
          viewport.offsetTop,
          window.scrollY
        )
      ) {
        window.scrollTo(0, 0)
      }
    }

    sync()
    viewport.addEventListener('resize', sync)
    viewport.addEventListener('scroll', sync)
    return () => {
      viewport.removeEventListener('resize', sync)
      viewport.removeEventListener('scroll', sync)
      applySoftKeyboardViewport(rootStyle, { keyboardOpen: false })
    }
  }, [enabled])
}
